export enum BodyClass {
  Dark = 'page-bg--dark',
  Grey = 'page-bg--grey',
}
